/**
 * @fileOverview Loads city data and passes it to child component.
 * Loads the following info and passes down as props
 * - clients
 * - campaigns
 * - locations
 */

import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import {
  getCountry,
  getDMPrintingCosts,
  getADMPrintingCosts,
  getStates,
  getPrinters,
} from './../../../Module/graphQL'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'

const CountryData = withRouter(props => {
  const { children, countryId, match, ...otherProps } = props

  const [country, setCountry] = useState(null)

  const { data, isLoaded, isLoading, refetch } = useGraphQLFetch({
    fetchFn: getCountry,
    defaultFetchArgs: countryId || match.params.id,
    fetchId: 'getCountry',
    mapResponse: result => result.country,
  })

  const {
    data: DMPrintingCosts,
    isLoaded: DMPrintingCostsLoaded,
    isLoading: DMPrintingCostsLoading,
    refetch: refetchDMPrintingCosts,
  } = useGraphQLFetch({
    fetchFn: getDMPrintingCosts,
    defaultFetchArgs: countryId || match.params.id,
    fetchId: 'getDMPrintingCosts',
    mapResponse: result => result.getDMPrintingCosts.DMPrintingCosts,
  })

  const {
    data: ADMPrintingCosts,
    isLoaded: ADMPrintingCostsLoaded,
    isLoading: ADMPrintingCostsLoading,
    refetch: refetchADMPrintingCosts,
  } = useGraphQLFetch({
    fetchFn: getADMPrintingCosts,
    defaultFetchArgs: countryId || match.params.id,
    fetchId: 'getADMPrintingCosts',
    mapResponse: result => result.getADMPrintingCosts.ADMPrintingCosts,
  })

  const {
    data: States,
    isLoaded: StatesLoaded,
    isLoading: StatesLoading,
    refetch: refetchStates,
  } = useGraphQLFetch({
    fetchFn: getStates,
    defaultFetchArgs: countryId || match.params.id,
    fetchId: 'getStates',
    mapResponse: result => result.getStates.States,
  })

  const {
    data: Printers,
    isLoaded: PrintersLoaded,
    isLoading: PrintersLoading,
    refetch: refetchPrinters,
  } = useGraphQLFetch({
    fetchFn: getPrinters,
    defaultFetchArgs: countryId || match.params.id,
    fetchId: 'getPrinters',
    mapResponse: result => result.getPrinters.Printers,
  })

  useEffect(() => {
    if (
      isLoaded &&
      DMPrintingCostsLoaded &&
      StatesLoaded &&
      PrintersLoaded &&
      ADMPrintingCostsLoaded
    ) {
      setCountry({
        ...data,
        DMPrintingCosts,
        States,
        Printers,
        ADMPrintingCosts,
      })
    }
  }, [
    isLoaded,
    DMPrintingCostsLoaded,
    StatesLoaded,
    PrintersLoaded,
    ADMPrintingCostsLoaded,
  ])

  return React.cloneElement(children, {
    ...otherProps,
    country,
    countryLoaded:
      !isLoading &&
      !DMPrintingCostsLoading &&
      !ADMPrintingCostsLoading &&
      !StatesLoading &&
      !PrintersLoading,
    refetch: () => {
      setCountry(null)
      refetch(countryId || match.params.id)
      refetchDMPrintingCosts(countryId || match.params.id)
      refetchADMPrintingCosts(countryId || match.params.id)
      refetchStates(countryId || match.params.id)
      refetchPrinters(countryId || match.params.id)
    },
  })
})

export default CountryData
